'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _config = require('./config');

var _findBabelOptionsForPlugin = require('./util/findBabelOptionsForPlugin');

var _findBabelOptionsForPlugin2 = _interopRequireDefault(_findBabelOptionsForPlugin);

var _compilerState = require('./state/compilerState');

var _firstPass = require('./visitors/firstPass');

var _firstPass2 = _interopRequireDefault(_firstPass);

var _secondPass = require('./visitors/secondPass');

var _secondPass2 = _interopRequireDefault(_secondPass);

var _thirdPass = require('./visitors/thirdPass');

var _thirdPass2 = _interopRequireDefault(_thirdPass);

var _main = require('./visitors/main');

var _main2 = _interopRequireDefault(_main);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function LightScript(babel) {
  var plugin = {
    manipulateOptions(opts, parserOpts, file) {
      // manipulateOptions is called very early in the Babel processing chain.
      // It doesn't get an opportunity to see the configuration options for the
      // plugin being run (without a workaround) nor does it get an
      // opportunity to see the code that will be compiled.
      //
      // This rules out things like parsing configuration directives from the
      // top of a JS file to manipulate parsing and compiling options.
      //
      // To remedy this, we monkey patch so that we can do initialization work
      // after the code is read, but before the parser runs.
      //
      // Relevant Babel code:
      // https://github.com/babel/babel/blob/4e50b2d9d9c376cee7a2cbf56553fe5b982ea53c/packages/babel-core/src/transformation/file/index.js#L63
      // https://github.com/babel/babel/blob/4e50b2d9d9c376cee7a2cbf56553fe5b982ea53c/packages/babel-core/src/transformation/file/index.js#L483
      var origAddCode = file.addCode;

      return file.addCode = function addCode(code) {
        origAddCode.call(this, code);
        var pluginOpts = (0, _findBabelOptionsForPlugin2.default)(this.opts, plugin);

        var compiler = (0, _compilerState.createCompilerState)(babel);
        this.lscCompiler = compiler;
        (0, _config.preParseInitialization)(compiler, this, pluginOpts);
        return;
      };
    }, visitor: {
      // The compiler's main loop is a Program visitor.
      Program(path, state) {
        // Skip non-LightScript code
        if (!state.file.isLightScript) return;

        // Obtain compiler state created during early processing
        var compiler = state.file.lscCompiler;

        ////////// Initialize compilation run
        (0, _compilerState.preCompileInitialization)(compiler, path);

        ////////// AST visitation and transformation
        // First pass: Perform basic ast fixups (block bodies, etc)
        (0, _firstPass2.default)(compiler, path);
        // Second pass: placeholders, comprehensions
        (0, _secondPass2.default)(compiler, path);
        // Third pass: transform optional chains
        (0, _thirdPass2.default)(compiler, path);
        // Main ast visitor
        (0, _main2.default)(compiler, path);

        ////////// Post-processing
        // Fix up loose ends like adding `import` statements
        (0, _compilerState.postprocess)(compiler);
      } }
  };
  return plugin;
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ../~/@oigroup/babel-plugin-lightscript/lib/index.js
// module id = 819
// module chunks = 0